import React from 'react';

const IconLogo = () => (
  <svg
    width="1095"
    height="945"
    viewBox="0 0 1095 945"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M759.73 365.58L1094.55 944.62H854.19L759.73 785.8L663.77 944.62H425.08L332.35 785.09L241.37 944.62H0L547.02 0L667.17 209.98L450.52 580.26L547.02 738.86L759.73 365.58Z"
      fill="#64FFDA"
    />
  </svg>
);

export default IconLogo;
